import React, { Component } from 'react';
import '../../../scss/components/pages/home.scss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Calendar from '../../Calendar';
import moment from 'moment';

import {
  getSupportScheduleShift,
  InitAPIStatus,
} from '../../../store/action';

class SupportShift extends Component {
  constructor(props) {
    super(props)
    this.state = {
      calendarConfig: {
        defaultView: "month",
        draggable: false,
        isEventClick: true,
        isDayClick: false,
        header: {
          left: 'today prev,next',
          center: 'title',
          right: 'month',
        },
      },
      jobType: [
        {
          id: 1,
          title: '預期上班人數',
          eventColor: 'skyblue'
        },{
          id: 3,
          title: '包場',
          eventColor: '#918682'
        },{
          id: 4,
          title: '課程',
          eventColor: '#918682'
        },{
          id: 5,
          title: '活動',
          eventColor: '#918682'
        },{
          id: 6,
          title: '調完班後的上班人數',
          eventColor: 'skyblue'
        },{
          id: 8,
          title: '國定假日',
          eventColor: '#71C171'
        },{
          id: 9,
          title: '當日營收',
          eventColor: '#347ED2'
        }
      ],
    }
    this.handleEventClick = this.handleEventClick.bind(this);
  }
  componentDidMount() {
    this.props.getSupportScheduleShift();
  }
  
  handleEventClick(event) {
    if (event.resourceId === "2") {
      this.props.history.push(`/supportStaffShiftDetail/${event.start.format('YYYY-MM-DD')}`);
    }
  }

  render() {
    let { events, eventStartTime, eventEndTime } = this.props.supportScheduleShiftState;

    events = events.map(event => {
      event.start = moment(event.start).format('YYYY-MM-DD');
      event.end = moment(event.end).format('YYYY-MM-DD');
      return event
    })

    return (
      <div className="p-home">
        <div className="u-block">
          <div className="u-title">支援班表</div>
          <Calendar {...this.state.calendarConfig}
            events={events} 
            resources={this.state.jobType} 
            startTime={eventStartTime}
            endTime={eventEndTime}

            eventClick={this.handleEventClick}
          />
        </div>
      </div>
    )
  }
}


const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  supportScheduleShiftState: store.supportScheduleShiftState,
})

export default connect(mapStateToProps,{
  getSupportScheduleShift,
  InitAPIStatus,
})(withRouter(SupportShift));